module.exports = __webpack_public_path__ + "static/media/game_icon.ead9d1ce.png";